import React from 'react';
import vars from '@variables';
import styled from '@emotion/styled/macro';
import Translate from '@utils/translation-functions';
import { GTM_ID } from '../../../../common/constants/gtmIds';
import { PillAtom } from '@atoms/text-atoms/text-atoms';
import { TagListProps } from './tag-list.types';

const TagList: React.FC<TagListProps> = ({ tags = [], className }) => {
  if (Array.isArray(tags) && tags.length > 0) {
    return (
      <ul className={className}>
        {tags.map(({ title }, index) => {
          return (
            <a
              data-testid={title}
              href={`/${Translate('exploreLink', true)}?topics=${title}`}
              key={`${title}-${index}`}
              data-gtm-id={GTM_ID.PILLS_SELECTOR}
              rel="noreferrer"
            >
              <PillAtom>{Translate(title, true)}</PillAtom>
            </a>
          );
        })}
      </ul>
    );
  }
  return null;
};

const StyledTagList = styled(TagList)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: space-between;

  ${PillAtom} {
    margin: 0 ${vars.spacingXs};
  }
`;

export default StyledTagList;
